export default {
   showAlert (title){
    let  alertBlock = document.querySelector('#alertBlock30');

    let type = 'alert-success';

    alertBlock.innerHTML = alertBlock.innerHTML +
      `<div id="alert" class="alert ${type} fade show" role="alert">
        <strong>${title} </strong>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>`;
    window.setTimeout(() => {
      let block = alertBlock.firstChild;
      if (block) {
        block.remove();
      }
    }, 2000);
   },

  fillHTMLElementsWithData(body, typeElements, prefix, arrData){
    // typeElements supports type input | textarea | select
    let allKeys = [];
    let newValue = '';

    if(arrData)
      allKeys = Object.keys(arrData);

    let allElements = body.querySelectorAll(typeElements);

      if(allElements)
        allElements.forEach((item, index) => {

          newValue = ''; 
          if(typeElements == 'select')
            newValue = null;

          allKeys.forEach((key, indexKey) => {
            if(key == (prefix + item.attributes.name.nodeValue))
              newValue = arrData[key];
          });
          
          item.value = newValue; 
          item.setAttribute('defaultvalue', newValue);
        });


  },
  
  eventFire(el, etype) {
    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      let evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  },
  checkDifferent(key, oldvalue, newValue){
    if (oldvalue != newValue)
      return `${key}=${newValue}&`;
    else 
      return '';
  },

  strArrayToJsonString(strArray){
    let answer = '["';
    let elements = strArray.split(',');
    if (elements) {
      elements.forEach((oneElement) => {
        // удалить первый и последнй пробел
        if(oneElement.length > 1)
            if (oneElement.substring(oneElement.length-1) == " ")
              oneElement = oneElement.substring(0, oneElement.length-1);
      
        if (oneElement.length > 1)
            if (oneElement.substring(0, 1) == " ")
              oneElement = oneElement.substring(1, oneElement.length);
        
        if (oneElement.length > 1) {
          answer += oneElement;
          answer += '","';
        }
      });
      if(answer.length > 5)
        answer = answer.substring(0, answer.length-3);
    }
    answer +='"]';
    return answer;
  },

  jsonStringToString(jsonStr){
    if (jsonStr && jsonStr.length >3) {
      jsonStr = this.replaceAllOneCharAtATime(jsonStr,'"','');
      jsonStr = jsonStr.replace('[','');
      jsonStr = jsonStr.replace(']','');
    };
    return jsonStr;
  },

  startLoadWaitImg() {

    setTimeout(this.startWaitImg, 500);
  },
  startWaitImg() {
    // console.log('startWaitImg');
    let allImgsNeedToLoad = document.querySelectorAll('.imgWait');
    // console.log(allImgsNeedToLoad);
    if(allImgsNeedToLoad)
    {
      let imgNeedToLoad = allImgsNeedToLoad[0];
      imgNeedToLoad.classList.remove('imgWait');
      imgNeedToLoad.addEventListener('load',startLoadWaitImg());
      // imgNeedToLoad.onload = self;
      imgNeedToLoad.src = imgNeedToLoad.attributes.srcwait.nodeValue;
      imgNeedToLoad.removeAttribute('srcwait');

      // setTimeout(
        // function(){ this.startWaitImg; },
        // 500
      // );
      
    }
  },

  jsonStringToStringgetElementBy(jsonStr, indexElement){
    let needElement = '';

    if (jsonStr && jsonStr.length >3) {
      let arrElemets = jsonStr.split('","');
      if(arrElemets.length > 0)
          arrElemets = jsonStr.split('", "');

      if(arrElemets.length > indexElement)
        needElement = arrElemets[indexElement];
      else
        needElement = jsonStr;

      needElement = this.replaceAllOneCharAtATime(needElement,'"','');
      needElement = needElement.replace('[','');
      needElement = needElement.replace(']','');
    };
    return needElement;
  },

 replaceAllOneCharAtATime(inSource, inToReplace, inReplaceWith) {
    var output="";
    var firstReplaceCompareCharacter = inToReplace.charAt(0);
    var sourceLength = inSource.length;
    var replaceLengthMinusOne = inToReplace.length - 1;
    for(var i = 0; i < sourceLength; i++){
        var currentCharacter = inSource.charAt(i);
        var compareIndex = i;
        var replaceIndex = 0;
        var sourceCompareCharacter = currentCharacter;
        var replaceCompareCharacter = firstReplaceCompareCharacter;
        while(true){
            if(sourceCompareCharacter != replaceCompareCharacter){
            output += currentCharacter;
            break;
        }
        if(replaceIndex >= replaceLengthMinusOne) {
            i+=replaceLengthMinusOne;
            output += inReplaceWith;
            //was a match
            break;
        }
        compareIndex++; replaceIndex++;
        if(i >= sourceLength){
            // not a match
            break;
        }
        sourceCompareCharacter = inSource.charAt(compareIndex)
            replaceCompareCharacter = inToReplace.charAt(replaceIndex);
        }   
        replaceCompareCharacter += currentCharacter;
    }
    return output;
  },
  inputAddLimit(objectInput, limitSymbols) {
    objectInput.setAttribute("maxlength", limitSymbols);
    let countListener = objectInput.getAttribute('countListeners');

    if(!countListener){

      objectInput.insertAdjacentHTML('beforebegin','<little class="ml-auto mr-1"></little>');
      let divCounter = objectInput.previousElementSibling;

        objectInput.addEventListener('keyup',function () {
        divCounter.innerHTML = '' + objectInput.value.length + '/' + limitSymbols;

        if(objectInput.value.length === limitSymbols)
          divCounter.classList.add('maxSizeAlert');
        else 
          divCounter.classList.remove('maxSizeAlert');

      });
      objectInput.setAttribute('countListeners',1);
    }

  },


  limitMe(evt, txt) {
      if (evt.which && evt.which == 8) 
        return true;
      else 
        return txt.value.length < txt.getAttribute("max_length");
  },


  checkEqualTwoInt(fInt, sInt)
  {
    if(parseInt(fInt, 10) === parseInt(sInt, 10))
      return true;
    else 
      return false;
  },

  removeOptions(selectbox) {
    for (let i = selectbox.options.length - 1; i >= 0; i--) {
      selectbox.remove(i);
    }
  },

  sendToTelegram($message) {
    $url = 'http://hardpush.bidone.ru/api/v2/telegram/'.urlencode($message);

  
    $ch = curl_init();

    curl_setopt($ch, CURLOPT_URL, $url);

    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);
    curl_setopt($ch, CURLOPT_HEADER, false);

    curl_exec($ch);
    curl_close($ch);
  },

  formatedPhone (strPhone) {
    strPhone = strPhone.toString()
    if(strPhone.length == 11)
      if(parseInt(strPhone.substr(0,1), 10) === 7)
        return `+7 (${strPhone.substr(1,3)}) ${strPhone.substr(4,3)} ${strPhone.substr(7,2)} ${strPhone.substr(9,2)}`;
      else  if(parseInt(strPhone.substr(0,1), 10) === 8)
        return `8 (${strPhone.substr(1,3)}) ${strPhone.substr(4,3)} ${strPhone.substr(7,2)} ${strPhone.substr(9,2)}`;

    return strPhone;
  },
  isNumeric(value) {
    return /^-?\d+$/.test(value);
  },
  texWithLinks(textl){

  if(typeof textl !== 'string')
    return textl;

  let indexes = [...textl.matchAll(new RegExp('https://', 'gi'))].map(a => a.index);
  let indexesSpaces = [...textl.matchAll(new RegExp(' ', 'gi'))].map(a => a.index);
  // console.log(indexes); // [2, 25, 27, 33]
  if (indexes && indexes.length > 0) {
    indexes.forEach((iElement) => {
      let was = false;
      console.log(iElement);
      // indexesSpaces.forEach((serachElements) = {});
      console.log(indexesSpaces.length);
      if (indexesSpaces.length === 0)
        textl = `<a href="${textl}" target="_blank">${textl}</a>`;
      else{
        indexesSpaces.forEach((sElement) => {
          if(iElement<sElement && !was){
            //делаем link 
            was = true;
            let strLink = textl.substring(iElement, sElement);
            let newLink = `<a href="${strLink}" target="_blank">${strLink}</a>`;
            textl = textl.replace(strLink, newLink);
          }
        });
        if(!was)
        {
          let strLink = textl.substring(iElement, textl.length);
          let newLink = `<a href="${strLink}" target="_blank">${strLink}</a>`;
          textl = textl.replace(strLink, newLink);
        }
      }
    });
  }

    return textl;
  },

  dateStringFull(dtStr) {

    dtStr = this.ifnull(dtStr);

    let correctStr = ' - ';
    if(dtStr.length >10)
      correctStr =  `${dtStr.substr(8, 2)} ${this.getMonthBeforeName(dtStr.substr(5, 2))}  ${dtStr.substr(0, 4)} ${dtStr.substr(10, 6)}`;
  
    return correctStr;
  },
  dateStringFullAddTimeZone(dtStr, timeZone) {

    dtStr = this.ifnull(dtStr);

    let dateZero = new Date(dtStr.substr(0, 4), dtStr.substr(5, 2) - 1, dtStr.substr(8, 2), parseInt(dtStr.substr(11, 2), 10) +  parseInt(timeZone, 10), dtStr.substr(14, 2), dtStr.substr(17, 2));

    let correctStr = ' - ';
    if(dtStr.length >10)
      correctStr =  `${dateZero.getDate()} ${this.getMonthBeforeName(dtStr.substr(5, 2))}  ${dtStr.substr(0, 4)} ${dateZero.getHours()}:${dateZero.getMinutes()<10 ? `0${dateZero.getMinutes()}`: dateZero.getMinutes()}`;
  
    return correctStr;
  },
  dateStringOnlyHoursWithMinAddTimeZone(dtStr, timeZone) {

    dtStr = this.ifnull(dtStr);

    let dateZero = new Date(dtStr.substr(0, 4), dtStr.substr(5, 2) - 1, dtStr.substr(8, 2), parseInt(dtStr.substr(11, 2), 10) +  parseInt(timeZone, 10), dtStr.substr(14, 2), dtStr.substr(17, 2));


    let correctStr = ' - ';
    if(dtStr.length >10)
      correctStr =  ` ${dateZero.getHours()}:${dateZero.getMinutes()<10 ? `0${dateZero.getMinutes()}`: dateZero.getMinutes()}`;
  
    return correctStr;
  },
  dateStringShort(dtStr){

    dtStr = this.ifnull(dtStr);

    let correctStr = ' - ';
    if(dtStr.length >10)
      correctStr = `${dtStr.substr(8, 2)} ${this.getMonthBeforeName(dtStr.substr(5, 2))}  ${dtStr.substr(0, 4)} `;
   
    return correctStr;
  },

  strToDate(dtStr) {
    if(!dtStr)
      return new Date();
   
    let dateParts = dtStr.split("-");
    let timeParts = dateParts[2].split(" ")[1].split(":");
    dateParts[2] = dateParts[2].split(" ")[0];
    return  new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },


  addZeroBefore(zValue){
    if(parseInt(zValue, 10) < 10)
      return `0${zValue}`;

    else 
      return zValue;
  },

  secToFormattedLabel(value){
    value = parseInt(value, 10)
    let lsec = value%(60);
    value -= lsec;
    value = value/60;
    let lmins = value%(60);;
    value -= lmins;
    value = value/60;
    let lhours =value;

    if(lmins < 10)
      lmins = `0${lmins}`;

    if(lsec < 10)
      lsec = `0${lsec}`;

    value = `${lhours}:${lmins}:${lsec}`;
    return value;
  },

  getMonthBeforeName(indexM) {
    --indexM;
    let monthNames = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];
    return monthNames[parseInt(indexM, 10)];
  },

  getMonthBeforeNameX(indexM) {
    --indexM;
    let monthNames = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    return monthNames[parseInt(indexM, 10)];
  },

  getNameTypePrograms(indexM) {
    
    let arrValues = [ 'Внеконкурс', 'Конкурс', 'Медиатека'];
    return arrValues[parseInt(indexM, 10)];
  },

  getNameTypeProgramsFull(indexM) {
    
    let arrValues = ['Внеконкурсная программа', 'Конкурсная программа',  'Медиатека'];
    return arrValues[parseInt(indexM, 10)];
  },


  // рассчитывает процент по стоимости и цене
  calcPercent(purchase, price) {
    let precent = ((price - purchase) * 100 / purchase).toFixed(2);

    if (!isFinite(precent)) {
      return 0;
    }

    return precent;
  },
  // рассчитывает цену по стоимости и проценту
  calcPrice(purchase, percent) {
    return (Number(purchase) + (purchase / 100 * percent)).toFixed(2);
  },

  // setup = {
  //   array: массив в котором искать
  //   property: свойство объекта (когда массив состоит из объектов). Если пустое, то ищется по массиву
  //   el: что искать
  //   strict: true/false - если true, то ищет значение целиком, если false - вхождение
  // }

  kmpSearch(pattern, text) {

    if (pattern.length == 0)
      return 0; // Immediate match

    pattern = pattern.toUpperCase();
    if (typeof text === 'string' || text instanceof String)
      text = text.toUpperCase();
    else if( typeof text === 'number')
      text = text.toString();

    // Compute longest suffix-prefix table
    var lsp = [0]; // Base case
    for (var i = 1; i < pattern.length; i++) {
      var j = lsp[i - 1]; // Start by assuming we're extending the previous LSP
      while (j > 0 && pattern.charAt(i) != pattern.charAt(j))
        j = lsp[j - 1];
      if (pattern.charAt(i) == pattern.charAt(j))
        j++;
      lsp.push(j);
    }

    // Walk through text string
    var j = 0; // Number of chars matched in pattern
    if(text)
      for (var i = 0; i < text.length; i++) {
        while (j > 0 && text.charAt(i) != pattern.charAt(j))
          j = lsp[j - 1]; // Fall back in the pattern
        if (text.charAt(i) == pattern.charAt(j)) {
          j++; // Next char matched, increment position
          if (j == pattern.length)
            return i - (j - 1);
        }
      }
    return -1; // Not found
  },
  serachElements(setup) {
    let indexes = [];

    setup.array.forEach((good) => {
      let el1 = (setup.property) ? good[setup.property].toLocaleLowerCase() : good.toLocaleLowerCase();
      let el2 = setup.el.toLocaleLowerCase();

      if (setup.strict) {
        if (el1 === el2) {
          indexes.push(good);
        }
      } else {
        if (el1.indexOf(el2) !== -1) {
          indexes.push(good);
        }
      }
    });

    if (indexes.length === 0) {
      return 'none';
    }
    return indexes;
  },

};
